import { DATA_SELECTOR_ID } from "../utils/context-layer-variables";
const STORE_CONTEXT_LAYER_ERROR = 'store-context-layer-error';
const STORE_SEARCH_ERROR = 'store-search-error';
export function insertErrorMessage(storeSearchContainer, message, showDecreasedModeButton = true) {
  const errorContainer = storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="${STORE_CONTEXT_LAYER_ERROR}"]`);
  if (errorContainer) {
    errorContainer.innerHTML = message;
    handleErrorContainerDisplay(storeSearchContainer, true, showDecreasedModeButton);
  }
}
export function clearErrorMessage(storeSearchContainer) {
  handleErrorContainerDisplay(storeSearchContainer, false, false);
}
function toggleVisibility(element, show) {
  if (!element) return;
  element.classList.remove(show ? 'kl-hidden' : 'kl-visible');
  element.classList.add(show ? 'kl-visible' : 'kl-hidden');
}
function handleErrorContainerDisplay(storeSearchContainer, showErrorContainer, showDecreasedModeButton) {
  const errorContainer = storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="${STORE_SEARCH_ERROR}"]`);
  toggleVisibility(errorContainer, showErrorContainer);
  const decreasedViewButton = storeSearchContainer.querySelector(`[${DATA_SELECTOR_ID}="store-search-decreased-button"]`);
  toggleVisibility(decreasedViewButton, showDecreasedModeButton);
}
export function getGeolocateErrorMessage(error) {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      return context_layer.i18n.geolocate_permission_error;
    case error.POSITION_UNAVAILABLE:
      return context_layer.i18n.geolocate_position_error;
    case error.TIMEOUT:
      return context_layer.i18n.geolocate_timeout_error;
    default:
      return context_layer.i18n.geolocate_unknown_error;
  }
}